import {Injectable} from '@angular/core';
import {UserService} from '../service/user.service';
import {Keys, StorageService} from '../service/storage.service';
import {Resolve} from '@angular/router';
import {PartnerService} from '../service/partner.service';

@Injectable()
export class ReferralConsentResolver implements Resolve<string> {
    public name: string;
    private userService: UserService;
    private storageService: StorageService;
    private partnerService: PartnerService;

    constructor(storageService: StorageService, userService: UserService, partnerService: PartnerService) {
        this.storageService = storageService;
        this.userService = userService;
        this.partnerService = partnerService;

    }

    public async resolve(): Promise<string> {
            return this.storageService.getObjectFromSession(Keys.REFERRER_USER_NAME);
    }
}
